// FIX 20260801-volumeui 動画の音量UI(YouTubeと同じ横バー常時表示・アイコンでミュート切替)
import React, { Component } from 'react';
import '../css/youtube_controls.scss';

export default class VideoVolumeBar extends Component {
  constructor(props) {
    super(props);
    this.state = { volume: 50, muted: true };
  }

  el = () => {
    const p = this.props.player;
    return (p && p.video && p.video.video) ? p.video.video : null;
  };

  sync = () => {
    const el = this.el();
    if (!el) return;
    this.setState({ volume: Math.round(el.volume * 100), muted: !!el.muted });
  };

  componentDidMount() {
    this._t = setInterval(() => {
      const el = this.el();
      if (!el) return;
      if (!this._hooked) {
        this._hooked = true;
        el.addEventListener('volumechange', this.sync);
      }
      this.sync();
      if (this._hooked) { clearInterval(this._t); this._t = null; }
    }, 300);
  }

  componentWillUnmount() {
    if (this._t) clearInterval(this._t);
    const el = this.el();
    if (el) el.removeEventListener('volumechange', this.sync);
  }

  toggleMute = (e) => {
    e.stopPropagation();
    const el = this.el();
    if (!el) return;
    if (el.muted || el.volume === 0) {
      if (el.volume === 0) el.volume = (this._keep != null ? this._keep : 0.5);
      el.muted = false;
    } else {
      this._keep = el.volume;
      el.muted = true;
    }
    this.sync();
  };

  onChange = (e) => {
    const el = this.el();
    if (!el) return;
    const v = parseInt(e.target.value, 10);
    el.volume = Math.min(Math.max(v / 100, 0), 1);
    el.muted = (v === 0);
    if (v > 0) this._keep = el.volume;
    this.sync();
  };

  render() {
    const { volume, muted } = this.state;
    const off = muted || volume === 0;
    return (
      <div className="youtube-volume-container video-volume-container">
        <button className="youtube-btn" onClick={this.toggleMute} title={off ? 'ミュート解除' : 'ミュート'}>
          {off ? (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"/>
            </svg>
          ) : volume < 50 ? (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"/>
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path fill="currentColor" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"/>
            </svg>
          )}
        </button>
        <div className="youtube-volume-slider visible">
          <input type="range" min="0" max="100" value={off ? 0 : volume}
                 onChange={this.onChange} className="youtube-volume-input" title="音量" />
        </div>
      </div>
    );
  }
}
